import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Typography } from '@mui/material';

import useInsuranceInfo from '../../../hooks/useInsuranceInfo';
import useAvailableCancellationDate from './useAvailableCancellationDate';
import {
  WITHDRAWAL_CANCELLATION_NO_PAYMENT_NO_CLAIM,
  WITHDRAWAL_CANCELLATION_EXPORTED_PAYMENT_NO_CLAIM,
  WITHDRAWAL_CANCELLATION_WITH_CLAIM,
  WITHDRAWAL_CANCELLATION_EXPORTED_PAYMENT_WITH_CLAIM,
  REGULAR_CANCELATION_INSIDE_MINIMUM_CONTRACT_DURATION_WITH_PAYOUT,
  REGULAR_CANCELATION_WITHOUT_EXPORTED_PAYMENTS_AND_CLAIMS,
  REGULAR_CANCELATION_EXPORTED_PAYMENTS_WITHOUT_CLAIMS,
  REGULAR_CANCELATION_CLAIMS_WITHOUT_EXPORTED_PAYMENTS,
  REGULAR_CANCELATION_WITH_EXPORTED_PAYMENTS_AND_CLAIMS,
  REGULAR_CANCELATION_WITH_IM_COVERAGE,
  REGULAR_CANCELATION_WITH_VIDEO_CONSULTATION,
} from '../ContractCancellationConstants';

import {
  StyledCancellationDate,
  StyledLandingPageNormalText,
  StyledButtonContainer,
} from './LandingPage.styled';

// withdrawal_cancellation_no_payment_no_claim
function LandingPageContentsWithdrawalCancellationNoPaymentNoClaim({
  handleExit,
  handleCancelContract,
  disableButton,
}) {
  return (
    <>
      <StyledLandingPageNormalText>
        <Typography variant="p">
          <FormattedMessage id="cancellation.contract.landing.page.warning1" />
        </Typography>
      </StyledLandingPageNormalText>

      <StyledLandingPageNormalText>
        <Typography variant="h3">
          <FormattedMessage id="cancellation.contract.landing.page.question" />
        </Typography>
      </StyledLandingPageNormalText>

      <StyledButtonContainer>
        <Button variant="outlined" onClick={handleExit}>
          <Typography variant="buttons">
            <FormattedMessage id="cancellation.contract.cancel.exit" />
          </Typography>
        </Button>

        <Button onClick={handleCancelContract} disabled={disableButton}>
          <Typography variant="buttons">
            <FormattedMessage id="cancellation.contract.confirm.continue" />
          </Typography>
        </Button>
      </StyledButtonContainer>
    </>
  );
}

// withdrawal_cancellation_exported_payment_no_claim
function LandingPageContentsWithdrawalCancellationExportedPaymentNoClaim({
  handleExit,
  handleCancelContract,
  disableButton,
}) {
  return (
    <>
      <StyledLandingPageNormalText>
        <Typography variant="p">
          <FormattedMessage id="cancellation.contract.landing.page.warning1" />
        </Typography>
      </StyledLandingPageNormalText>

      <StyledLandingPageNormalText>
        <Typography variant="p">
          <FormattedMessage id="cancellation.contract.landing.page.warning2" />
        </Typography>
      </StyledLandingPageNormalText>

      <StyledLandingPageNormalText>
        <Typography variant="h3">
          <FormattedMessage id="cancellation.contract.landing.page.question" />
        </Typography>
      </StyledLandingPageNormalText>

      <StyledButtonContainer>
        <Button variant="outlined" onClick={handleExit}>
          <Typography variant="buttons">
            <FormattedMessage id="cancellation.contract.cancel.exit" />
          </Typography>
        </Button>

        <Button onClick={handleCancelContract} disabled={disableButton}>
          <Typography variant="buttons">
            <FormattedMessage id="cancellation.contract.confirm.continue" />
          </Typography>
        </Button>
      </StyledButtonContainer>
    </>
  );
}

// withdrawal_cancellation_with_claim
function LandingPageContentsWithdrawalCancellationWithClaim({
  handleExit,
  handleCancelContract,
  disableButton,
}) {
  return (
    <>
      <StyledLandingPageNormalText>
        <Typography variant="p">
          <FormattedMessage id="cancellation.contract.landing.page.warning1" />
        </Typography>
      </StyledLandingPageNormalText>

      <StyledLandingPageNormalText>
        <Typography variant="p">
          <FormattedMessage id="cancellation.contract.landing.page.warning3" />
        </Typography>
      </StyledLandingPageNormalText>

      <StyledLandingPageNormalText>
        <Typography variant="h3">
          <FormattedMessage id="cancellation.contract.landing.page.question" />
        </Typography>
      </StyledLandingPageNormalText>

      <StyledButtonContainer>
        <Button variant="outlined" onClick={handleExit}>
          <Typography variant="buttons">
            <FormattedMessage id="cancellation.contract.cancel.exit" />
          </Typography>
        </Button>

        <Button onClick={handleCancelContract} disabled={disableButton}>
          <Typography variant="buttons">
            <FormattedMessage id="cancellation.contract.confirm.continue" />
          </Typography>
        </Button>
      </StyledButtonContainer>
    </>
  );
}

// withdrawal_cancellation_exported_payment_with_claim
function LandingPageContentsWithdrawalCancellationExportedPaymentWithClaim({
  handleExit,
  handleCancelContract,
  disableButton,
}) {
  return (
    <>
      <StyledLandingPageNormalText>
        <Typography variant="p">
          <FormattedMessage id="cancellation.contract.landing.page.warning1" />
        </Typography>
      </StyledLandingPageNormalText>

      <StyledLandingPageNormalText>
        <Typography variant="p">
          <FormattedMessage id="cancellation.contract.landing.page.warning4" />
        </Typography>
      </StyledLandingPageNormalText>

      <StyledLandingPageNormalText>
        <Typography variant="h3">
          <FormattedMessage id="cancellation.contract.landing.page.question" />
        </Typography>
      </StyledLandingPageNormalText>

      <StyledLandingPageNormalText>
        <Typography variant="p">
          <FormattedMessage id="cancellation.contract.landing.page.warning2" />
        </Typography>
      </StyledLandingPageNormalText>

      <StyledButtonContainer>
        <Button variant="outlined" onClick={handleExit}>
          <Typography variant="buttons">
            <FormattedMessage id="cancellation.contract.cancel.exit" />
          </Typography>
        </Button>

        <Button onClick={handleCancelContract} disabled={disableButton}>
          <Typography variant="buttons">
            <FormattedMessage id="cancellation.contract.confirm.continue" />
          </Typography>
        </Button>
      </StyledButtonContainer>
    </>
  );
}

// regular_cancelation_inside_minimum_contract_duration_with_payout
function LandingPageContentsRegularCancelationInsideMinimumContractDurationWithPayout({
  handleExit,
  handleCancelContract,
  disableButton,
}) {
  const availableCancellationDate = useAvailableCancellationDate();
  const { type } = useInsuranceInfo();

  return (
    <>
      <StyledLandingPageNormalText>
        <Typography variant="p">
          <FormattedMessage id="cancellation.contract.landing.page.regular.text1" tagName="p" />
        </Typography>
      </StyledLandingPageNormalText>

      {availableCancellationDate && (
        <>
          <StyledLandingPageNormalText>
            <Typography variant="h3">
              <FormattedMessage id="cancellation.contract.landing.page.regular.next_possible_date" />
            </Typography>
          </StyledLandingPageNormalText>

          <StyledCancellationDate type={type}>
            <Typography variant="h3">{availableCancellationDate}</Typography>
          </StyledCancellationDate>
        </>
      )}

      <StyledButtonContainer>
        <Button variant="outlined" onClick={handleExit}>
          <Typography variant="buttons">
            <FormattedMessage id="cancellation.contract.cancel.exit" />
          </Typography>
        </Button>

        <Button onClick={handleCancelContract} disabled={disableButton}>
          <Typography variant="buttons">
            <FormattedMessage id="cancellation.contract.confirm.cancel" />
          </Typography>
        </Button>
      </StyledButtonContainer>
    </>
  );
}

// regular_cancelation_without_exported_payments_and_claims
function LandingPageContentsRegularCancelationWithoutExportedPaymentsAndClaims({
  handleExit,
  handleCancelContract,
  disableButton,
}) {
  const availableCancellationDate = useAvailableCancellationDate();
  const { type } = useInsuranceInfo();

  return (
    <>
      <StyledLandingPageNormalText>
        <Typography variant="p">
          <FormattedMessage id="cancellation.contract.landing.page.regular.text2" />
        </Typography>
      </StyledLandingPageNormalText>

      {availableCancellationDate && (
        <>
          <StyledLandingPageNormalText>
            <Typography variant="h3">
              <FormattedMessage id="cancellation.contract.landing.page.regular.next_possible_date" />
            </Typography>
          </StyledLandingPageNormalText>

          <StyledCancellationDate type={type}>
            <Typography variant="h3">{availableCancellationDate}</Typography>
          </StyledCancellationDate>
        </>
      )}

      <StyledButtonContainer>
        <Button variant="outlined" onClick={handleExit}>
          <Typography variant="buttons">
            <FormattedMessage id="cancellation.contract.cancel.exit" />
          </Typography>
        </Button>

        <Button onClick={handleCancelContract} disabled={disableButton}>
          <Typography variant="buttons">
            <FormattedMessage id="cancellation.contract.confirm.cancel" />
          </Typography>
        </Button>
      </StyledButtonContainer>
    </>
  );
}

// regular_cancelation_exported_payments_without_claims
function LandingPageContentsRegularCancelationExportedPaymentsWithoutClaims({
  handleExit,
  handleCancelContract,
  disableButton,
}) {
  const availableCancellationDate = useAvailableCancellationDate();
  const { type } = useInsuranceInfo();

  return (
    <>
      <StyledLandingPageNormalText>
        <Typography variant="p">
          <FormattedMessage id="cancellation.contract.landing.page.regular.text2" />
        </Typography>
      </StyledLandingPageNormalText>

      {availableCancellationDate && (
        <>
          <StyledLandingPageNormalText>
            <Typography variant="h3">
              <FormattedMessage id="cancellation.contract.landing.page.regular.next_possible_date" />
            </Typography>
          </StyledLandingPageNormalText>

          <StyledCancellationDate type={type}>
            <Typography variant="h3">{availableCancellationDate}</Typography>
          </StyledCancellationDate>
        </>
      )}

      <StyledLandingPageNormalText>
        <Typography variant="p">
          <FormattedMessage id="cancellation.contract.landing.page.regular.text3" />
        </Typography>
      </StyledLandingPageNormalText>

      <StyledButtonContainer>
        <Button variant="outlined" onClick={handleExit}>
          <Typography variant="buttons">
            <FormattedMessage id="cancellation.contract.cancel.exit" />
          </Typography>
        </Button>

        <Button onClick={handleCancelContract} disabled={disableButton}>
          <Typography variant="buttons">
            <FormattedMessage id="cancellation.contract.confirm.cancel" />
          </Typography>
        </Button>
      </StyledButtonContainer>
    </>
  );
}

// regular_cancelation_claims_without_exported_payments
function LandingPageContentsRegularCancelationClaimsWithoutExportedPayments({
  handleExit,
  handleCancelContract,
  disableButton,
}) {
  const availableCancellationDate = useAvailableCancellationDate();
  const { type } = useInsuranceInfo();

  return (
    <>
      <StyledLandingPageNormalText>
        <Typography variant="p">
          <FormattedMessage id="cancellation.contract.landing.page.regular.text2" />
        </Typography>
      </StyledLandingPageNormalText>

      {availableCancellationDate && (
        <>
          <StyledLandingPageNormalText>
            <Typography variant="h3">
              <FormattedMessage id="cancellation.contract.landing.page.regular.next_possible_date" />
            </Typography>
          </StyledLandingPageNormalText>

          <StyledCancellationDate type={type}>
            <Typography variant="h3">{availableCancellationDate}</Typography>
          </StyledCancellationDate>
        </>
      )}

      <StyledLandingPageNormalText>
        <Typography variant="p">
          <FormattedMessage id="cancellation.contract.landing.page.regular.text4" />
        </Typography>
      </StyledLandingPageNormalText>

      <StyledButtonContainer>
        <Button variant="outlined" onClick={handleExit}>
          <Typography variant="buttons">
            <FormattedMessage id="cancellation.contract.cancel.exit" />
          </Typography>
        </Button>

        <Button onClick={handleCancelContract} disabled={disableButton}>
          <Typography variant="buttons">
            <FormattedMessage id="cancellation.contract.confirm.cancel" />
          </Typography>
        </Button>
      </StyledButtonContainer>
    </>
  );
}

// regular_cancelation_with_exported_payments_and_claims
function LandingPageContentsRegularCancelationWithExportedPaymentsAndClaims({
  handleExit,
  handleCancelContract,
  disableButton,
}) {
  const availableCancellationDate = useAvailableCancellationDate();
  const { type } = useInsuranceInfo();

  return (
    <>
      <StyledLandingPageNormalText>
        <Typography variant="p">
          <FormattedMessage id="cancellation.contract.landing.page.regular.text2" />
        </Typography>
      </StyledLandingPageNormalText>

      {availableCancellationDate && (
        <>
          <StyledLandingPageNormalText>
            <Typography variant="h3">
              <FormattedMessage id="cancellation.contract.landing.page.regular.next_possible_date" />
            </Typography>
          </StyledLandingPageNormalText>

          <StyledCancellationDate type={type}>
            <Typography variant="h3">{availableCancellationDate}</Typography>
          </StyledCancellationDate>
        </>
      )}

      <StyledLandingPageNormalText>
        <Typography variant="p">
          <FormattedMessage id="cancellation.contract.landing.page.regular.text4" />
        </Typography>
      </StyledLandingPageNormalText>

      <StyledLandingPageNormalText>
        <Typography variant="p">
          <FormattedMessage id="cancellation.contract.landing.page.regular.text3" />
        </Typography>
      </StyledLandingPageNormalText>

      <StyledButtonContainer>
        <Button variant="outlined" onClick={handleExit}>
          <Typography variant="buttons">
            <FormattedMessage id="cancellation.contract.cancel.exit" />
          </Typography>
        </Button>

        <Button onClick={handleCancelContract} disabled={disableButton}>
          <Typography variant="buttons">
            <FormattedMessage id="cancellation.contract.confirm.cancel" />
          </Typography>
        </Button>
      </StyledButtonContainer>
    </>
  );
}

// regular_cancelation_with_im_coverage
function LandingPageContentsRegularCancelationWithImCoverage({
  handleExit,
  handleCancelContract,
  disableButton,
}) {
  const availableCancellationDate = useAvailableCancellationDate();
  const { type } = useInsuranceInfo();

  return (
    <>
      <StyledLandingPageNormalText>
        <Typography variant="p">
          <FormattedMessage id="cancellation.contract.landing.page.regular.text5" />
        </Typography>
      </StyledLandingPageNormalText>

      {availableCancellationDate && (
        <>
          <StyledLandingPageNormalText>
            <Typography variant="h3">
              <FormattedMessage id="cancellation.contract.landing.page.regular.next_possible_date" />
            </Typography>
          </StyledLandingPageNormalText>

          <StyledCancellationDate type={type}>
            <Typography variant="h3">{availableCancellationDate}</Typography>
          </StyledCancellationDate>
        </>
      )}

      <StyledButtonContainer>
        <Button variant="outlined" onClick={handleExit}>
          <Typography variant="buttons">
            <FormattedMessage id="cancellation.contract.cancel.exit" />
          </Typography>
        </Button>

        <Button onClick={handleCancelContract} disabled={disableButton}>
          <Typography variant="buttons">
            <FormattedMessage id="cancellation.contract.confirm.cancel" />
          </Typography>
        </Button>
      </StyledButtonContainer>
    </>
  );
}

// regular_cancelation_with_video_consultation
function LandingPageContentsRegularCancelationWithVideoConsultation({
  handleExit,
  handleCancelContract,
  disableButton,
}) {
  const availableCancellationDate = useAvailableCancellationDate();
  const { type } = useInsuranceInfo();

  return (
    <>
      <StyledLandingPageNormalText>
        <Typography variant="p">
          <FormattedMessage id="cancellation.contract.landing.page.regular.text1" />
        </Typography>
      </StyledLandingPageNormalText>

      {availableCancellationDate && (
        <>
          <StyledLandingPageNormalText>
            <Typography variant="h3">
              <FormattedMessage id="cancellation.contract.landing.page.regular.next_possible_date" />
            </Typography>
          </StyledLandingPageNormalText>

          <StyledCancellationDate type={type}>
            <Typography variant="h3">{availableCancellationDate}</Typography>
          </StyledCancellationDate>
        </>
      )}

      <StyledButtonContainer>
        <Button variant="outlined" onClick={handleExit}>
          <Typography variant="buttons">
            <FormattedMessage id="cancellation.contract.cancel.exit" />
          </Typography>
        </Button>

        <Button onClick={handleCancelContract} disabled={disableButton}>
          <Typography variant="buttons">
            <FormattedMessage id="cancellation.contract.confirm.cancel" />
          </Typography>
        </Button>
      </StyledButtonContainer>
    </>
  );
}

export default function LandingPageContents({
  cancellationPageKey,
  handleExit,
  handleCancelContract,
  disableButton,
}) {
  switch (cancellationPageKey) {
    case WITHDRAWAL_CANCELLATION_NO_PAYMENT_NO_CLAIM:
      return (
        <LandingPageContentsWithdrawalCancellationNoPaymentNoClaim
          handleExit={handleExit}
          handleCancelContract={handleCancelContract}
          disableButton={disableButton}
        />
      );
    case WITHDRAWAL_CANCELLATION_EXPORTED_PAYMENT_NO_CLAIM:
      return (
        <LandingPageContentsWithdrawalCancellationExportedPaymentNoClaim
          handleExit={handleExit}
          handleCancelContract={handleCancelContract}
          disableButton={disableButton}
        />
      );
    case WITHDRAWAL_CANCELLATION_WITH_CLAIM:
      return (
        <LandingPageContentsWithdrawalCancellationWithClaim
          handleExit={handleExit}
          handleCancelContract={handleCancelContract}
          disableButton={disableButton}
        />
      );
    case WITHDRAWAL_CANCELLATION_EXPORTED_PAYMENT_WITH_CLAIM:
      return (
        <LandingPageContentsWithdrawalCancellationExportedPaymentWithClaim
          handleExit={handleExit}
          handleCancelContract={handleCancelContract}
          disableButton={disableButton}
        />
      );
    case REGULAR_CANCELATION_INSIDE_MINIMUM_CONTRACT_DURATION_WITH_PAYOUT:
      return (
        <LandingPageContentsRegularCancelationInsideMinimumContractDurationWithPayout
          handleExit={handleExit}
          handleCancelContract={handleCancelContract}
          disableButton={disableButton}
        />
      );
    case REGULAR_CANCELATION_WITHOUT_EXPORTED_PAYMENTS_AND_CLAIMS:
      return (
        <LandingPageContentsRegularCancelationWithoutExportedPaymentsAndClaims
          handleExit={handleExit}
          handleCancelContract={handleCancelContract}
          disableButton={disableButton}
        />
      );
    case REGULAR_CANCELATION_EXPORTED_PAYMENTS_WITHOUT_CLAIMS:
      return (
        <LandingPageContentsRegularCancelationExportedPaymentsWithoutClaims
          handleExit={handleExit}
          handleCancelContract={handleCancelContract}
          disableButton={disableButton}
        />
      );
    case REGULAR_CANCELATION_CLAIMS_WITHOUT_EXPORTED_PAYMENTS:
      return (
        <LandingPageContentsRegularCancelationClaimsWithoutExportedPayments
          handleExit={handleExit}
          handleCancelContract={handleCancelContract}
          disableButton={disableButton}
        />
      );
    case REGULAR_CANCELATION_WITH_EXPORTED_PAYMENTS_AND_CLAIMS:
      return (
        <LandingPageContentsRegularCancelationWithExportedPaymentsAndClaims
          handleExit={handleExit}
          handleCancelContract={handleCancelContract}
          disableButton={disableButton}
        />
      );
    case REGULAR_CANCELATION_WITH_IM_COVERAGE:
      return (
        <LandingPageContentsRegularCancelationWithImCoverage
          handleExit={handleExit}
          handleCancelContract={handleCancelContract}
          disableButton={disableButton}
        />
      );
    case REGULAR_CANCELATION_WITH_VIDEO_CONSULTATION:
      return (
        <LandingPageContentsRegularCancelationWithVideoConsultation
          handleExit={handleExit}
          handleCancelContract={handleCancelContract}
          disableButton={disableButton}
        />
      );
    default:
      return null;
  }
}
